import { SvgIcon } from '@mui/material';

/* eslint-disable-next-line */
export interface CcfErrorFilledIconProps {}

/**
 * Component to display CcfErrorFilledIcon wow icon
 * @param props -CcfErrorFilledIcon
 * @returns svg icon of CcfErrorFilledIcon wow
 * @example <CcfErrorFilledIcon/>
 */
export function CcfErrorFilledIcon(props: CcfErrorFilledIconProps) {
  return (
    <SvgIcon
      {...props}
      width="25"
      height="24"
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5005 2.68286C7.04869 2.68286 2.62402 6.85691 2.62402 11.9999C2.62402 17.143 7.04869 21.317 12.5005 21.317C17.9523 21.317 22.377 17.143 22.377 11.9999C22.377 6.85691 17.9523 2.68286 12.5005 2.68286ZM13.4882 16.6585H11.5129V14.7951H13.4882V16.6585ZM13.4882 12.9316H11.5129V7.3414H13.4882V12.9316Z"
        fill="#D32F2F"
      />
    </SvgIcon>
  );
}

export default CcfErrorFilledIcon;
